const QuestionEditionPage: React.FC = () => {
  return (
    <div>
      <h1>Question Edition Page</h1>
    </div>
  );
};
export default QuestionEditionPage;
